export default function VendorsDirective() {
  return {
    template: require('./vendors.html'),
    scope: {
      vendors: '=',
      riskTiers: '=',
    },
    controller: 'VendorsController',
    controllerAs: 'vendorsVM',
    bindToController: true,
    replace: true,
  };
}
